/* ------------------------------------------------------------------ *
 * Which product types go with the casket cover.
 *
 * One rule for every screen that splits a funeral order into "casket
 * cover" and "tributes" — the work order list, the day sheet, the run
 * sheet stops, the order form — and for the server's counts: the business's
 * own Settings → Product types, "Casket cover" category (settings.cc_types),
 * plus the Casket cover type itself. Which form section a product was added
 * in does not decide it — with the one exception below.
 *
 * Only the "Casket cover" type IS a casket cover. Singles, petals and the
 * other ticked types travel with it, but are never counted as one.
 *
 * One exception, per line: a ticked type added in the Tributes half of the
 * order form (thirty singles for the family, say) is saved with
 * `as_tribute: true` and is a tribute everywhere — list column, day sheet,
 * run sheet stop, counts. Lines from before the flag carry none, so for
 * them the type alone decides.
 * ------------------------------------------------------------------ */

const norm = (type) => String(type || "").trim().toLowerCase();

export const isCasketCover = (type) => norm(type) === "casket cover";

/** settings.cc_types (a JSON array, or already parsed) -> type names. */
export function casketTypesOf(settings) {
  const raw = settings && settings.cc_types;
  let list = raw;
  if (typeof raw === "string") {
    try {
      list = JSON.parse(raw || "[]");
    } catch (e) {
      list = [];
    }
  }
  return Array.isArray(list) ? list.map(String) : [];
}

/** True when a product of this type rides with the casket cover. */
export function goesWithCasket(type, casketTypes) {
  if (isCasketCover(type)) return true;
  const t = norm(type);
  return (casketTypes || []).some((c) => norm(c) === t);
}

/** True when this saved line rides with the casket cover: its type goes
 *  with it, unless the line was ordered as a tribute. The Casket cover type
 *  itself always does. */
export function lineGoesWithCasket(line, casketTypes) {
  const type = line && line.product_type;
  if (isCasketCover(type)) return true;
  if (line && line.as_tribute) return false;
  return goesWithCasket(type, casketTypes);
}
